import React, { useState, useEffect } from 'react';
import ModuleTemplate from '../../ModuleTemplate';
import { useSpeakAnswer } from '../../lib/useSpeakAnswer';
import { useInstructionAudio } from '../../lib/useInstructionAudio';
import { fallbackWrongKey } from '../../lib/speechAnswerEvaluator';
import './DailyRoutine.css';

/* eslint-disable react-hooks/exhaustive-deps */

const S3_BASE_URL = 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/awareness';

const ZONES = [
  { key: 'winter', name: 'Зима' },
  { key: 'spring', name: 'Весна' },
  { key: 'summer', name: 'Лето' },
  { key: 'autumn', name: 'Осень' }
];

const TASKS_BY_AGE = {
  '4': [
    { id: 'snowman', text: 'Лепим снеговика', img: 'winter_snowman', correctZone: 'winter' },
    { id: 'sled', text: 'Катаемся на санках', img: 'winter_boy', correctZone: 'winter' },
    { id: 'umbrells', text: 'Холодает и начинаются дожди', img: 'fall_umbrella', correctZone: 'autumn' },
    { id: 'footbal', text: 'Теплеет и уже можно играть в футбол на улице', img: 'spring_football', correctZone: 'spring' },
    { id: 'sea', text: 'Купаемся в море', img: 'summer_sea', correctZone: 'summer' },
    { id: 'ny', text: 'Празднуем новый год', img: 'winter_ny', correctZone: 'winter' },
    { id: 'bike', text: 'Уже тепло и можно кататься на велосипеде', img: 'summer_bike', correctZone: 'spring' },
    { id: 'bike', text: 'Жарко. Запускаем воздушного змея', img: 'summer_kids', correctZone: 'summer' },
    { id: 'flowers', text: 'Распускаются подснежники', img: 'spring_flowers', correctZone: 'spring' },
    { id: 'watermelon', text: 'Едим арбузы', img: 'summer_watermelon', correctZone: 'summer' },
    { id: 'school', text: 'Возвращаемся в школу после летникх каникул', img: 'fall_school', correctZone: 'autumn' },
    { id: 'spring_kids', text: 'Запускаем кораблики', img: 'spring_kids', correctZone: 'spring' },
    { id: 'birds', text: 'Птицы улетают на юг', img: 'fall_birds', correctZone: 'autumn' },
  ],
  '5': [
    { id: 'snowman', text: 'Лепим снеговика', img: 'winter_snowman', correctZone: 'winter' },
    { id: 'sled', text: 'Катаемся на санках', img: 'winter_boy', correctZone: 'winter' },
    { id: 'umbrells', text: 'Холодает и начинаются дожди', img: 'fall_umbrella', correctZone: 'autumn' },
    { id: 'footbal', text: 'Теплеет и уже можно играть в футбол на улице', img: 'spring_football', correctZone: 'spring' },
    { id: 'sea', text: 'Купаемся в море', img: 'summer_sea', correctZone: 'summer' },
    { id: 'ny', text: 'Празднуем новый год', img: 'winter_ny', correctZone: 'winter' },
    { id: 'bike', text: 'Уже тепло и можно кататься на велосипеде', img: 'summer_bike', correctZone: 'spring' },
    { id: 'bike', text: 'Жарко. Запускаем воздушного змея', img: 'summer_kids', correctZone: 'summer' },
    { id: 'flowers', text: 'Распускаются подснежники', img: 'spring_flowers', correctZone: 'spring' },
    { id: 'watermelon', text: 'Едим арбузы', img: 'summer_watermelon', correctZone: 'summer' },
    { id: 'school', text: 'Возвращаемся в школу после летникх каникул', img: 'fall_school', correctZone: 'autumn' },
    { id: 'spring_kids', text: 'Запускаем кораблики', img: 'spring_kids', correctZone: 'spring' },
    { id: 'birds', text: 'Птицы улетают на юг', img: 'fall_birds', correctZone: 'autumn' },
  ],
  '6': [
    { id: 'snowman', text: 'Лепим снеговика', img: 'winter_snowman', correctZone: 'winter' },
    { id: 'sled', text: 'Катаемся на санках', img: 'winter_boy', correctZone: 'winter' },
    { id: 'umbrells', text: 'Холодает и начинаются дожди', img: 'fall_umbrella', correctZone: 'autumn' },
    { id: 'footbal', text: 'Теплеет и уже можно играть в футбол на улице', img: 'spring_football', correctZone: 'spring' },
    { id: 'sea', text: 'Купаемся в море', img: 'summer_sea', correctZone: 'summer' },
    { id: 'ny', text: 'Празднуем новый год', img: 'winter_ny', correctZone: 'winter' },
    { id: 'bike', text: 'Уже тепло и можно кататься на велосипеде', img: 'summer_bike', correctZone: 'spring' },
    { id: 'bike', text: 'Жарко. Запускаем воздушного змея', img: 'summer_kids', correctZone: 'summer' },
    { id: 'flowers', text: 'Распускаются подснежники', img: 'spring_flowers', correctZone: 'spring' },
    { id: 'watermelon', text: 'Едим арбузы', img: 'summer_watermelon', correctZone: 'summer' },
    { id: 'school', text: 'Возвращаемся в школу после летникх каникул', img: 'fall_school', correctZone: 'autumn' },
    { id: 'spring_kids', text: 'Запускаем кораблики', img: 'spring_kids', correctZone: 'spring' },
    { id: 'birds', text: 'Птицы улетают на юг', img: 'fall_birds', correctZone: 'autumn' },

  ],
  '7-9': [
    { id: 'snowman', text: 'Лепим снеговика', img: 'winter_snowman', correctZone: 'winter' },
    { id: 'sled', text: 'Катаемся на санках', img: 'winter_boy', correctZone: 'winter' },
    { id: 'umbrells', text: 'Холодает и начинаются дожди', img: 'fall_umbrella', correctZone: 'autumn' },
    { id: 'footbal', text: 'Теплеет и уже можно играть в футбол на улице', img: 'spring_football', correctZone: 'spring' },
    { id: 'sea', text: 'Купаемся в море', img: 'summer_sea', correctZone: 'summer' },
    { id: 'ny', text: 'Празднуем новый год', img: 'winter_ny', correctZone: 'winter' },
    { id: 'bike', text: 'Уже тепло и можно кататься на велосипеде', img: 'summer_bike', correctZone: 'spring' },
    { id: 'bike', text: 'Жарко. Запускаем воздушного змея', img: 'summer_kids', correctZone: 'summer' },
    { id: 'flowers', text: 'Распускаются подснежники', img: 'spring_flowers', correctZone: 'spring' },
    { id: 'watermelon', text: 'Едим арбузы', img: 'summer_watermelon', correctZone: 'summer' },
    { id: 'school', text: 'Возвращаемся в школу после летникх каникул', img: 'fall_school', correctZone: 'autumn' },
    { id: 'spring_kids', text: 'Запускаем кораблики', img: 'spring_kids', correctZone: 'spring' },
    { id: 'birds', text: 'Птицы улетают на юг', img: 'fall_birds', correctZone: 'autumn' },

  ],
  '10-12': [
    { id: 'snowman', text: 'Лепим снеговика', img: 'winter_snowman', correctZone: 'winter' },
    { id: 'sled', text: 'Катаемся на санках', img: 'winter_boy', correctZone: 'winter' },
    { id: 'umbrells', text: 'Холодает и начинаются дожди', img: 'fall_umbrella', correctZone: 'autumn' },
    { id: 'footbal', text: 'Теплеет и уже можно играть в футбол на улице', img: 'spring_football', correctZone: 'spring' },
    { id: 'sea', text: 'Купаемся в море', img: 'summer_sea', correctZone: 'summer' },
    { id: 'ny', text: 'Празднуем новый год', img: 'winter_ny', correctZone: 'winter' },
    { id: 'bike', text: 'Уже тепло и можно кататься на велосипеде', img: 'summer_bike', correctZone: 'spring' },
    { id: 'bike', text: 'Жарко. Запускаем воздушного змея', img: 'summer_kids', correctZone: 'summer' },
    { id: 'flowers', text: 'Распускаются подснежники', img: 'spring_flowers', correctZone: 'spring' },
    { id: 'watermelon', text: 'Едим арбузы', img: 'summer_watermelon', correctZone: 'summer' },
    { id: 'school', text: 'Возвращаемся в школу после летникх каникул', img: 'fall_school', correctZone: 'autumn' },
    { id: 'spring_kids', text: 'Запускаем кораблики', img: 'spring_kids', correctZone: 'spring' },
    { id: 'birds', text: 'Птицы улетают на юг', img: 'fall_birds', correctZone: 'autumn' },
 ],
};

const ZONE_CANDIDATES = ZONES.map(zone => ({ key: zone.key, text: zone.name }));

const Seasons = ({ ageGroup, onBack, onStartPause, onComplete }) => {
  const { start: startSpeakRecognition } = useSpeakAnswer('Seasons');
  const { play: playInstruction, stop: stopInstruction } = useInstructionAudio();

  const [selectedMode, setSelectedMode] = useState(null);
  const [blinkTarget, setBlinkTarget] = useState('speak');

  const [isListening, setIsListening] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [hasSpoken, setHasSpoken] = useState(false);
  const [recognizerReady, setRecognizerReady] = useState(false);

  const [currentTaskIndex, setCurrentTaskIndex] = useState(0);
  const [selectedCard, setSelectedCard] = useState(null);
  const [zones, setZones] = useState({ winter: [], spring: [], summer: [], autumn: [] });
  const [answers, setAnswers] = useState([]);
  const [answerLog, setAnswerLog] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const tasks = TASKS_BY_AGE[ageGroup] || TASKS_BY_AGE['4'];
  const currentTask = tasks[currentTaskIndex];
  const totalQuestions = tasks.length;

  useEffect(() => {
    if (selectedMode) return;
    const interval = setInterval(() => {
      setBlinkTarget(prev => (prev === 'speak' ? 'show' : 'speak'));
    }, 700);
    return () => clearInterval(interval);
  }, [selectedMode]);

  // Озвучка текста задания + (в режиме "Говорить") запуск распознавателя —
  // одновременно, а не распознаватель только после озвучки, чтобы он успел
  // подключить микрофон к моменту, когда ребёнок услышит задание.
  useEffect(() => {
    if (currentTask && !hasSpoken && selectedMode && !showResult) {
      setHasSpoken(true);
      setIsListening(true);
      setIsSpeaking(false);
      setRecognizerReady(false);
      setSelectedCard(null);

      if (selectedMode === 'speak') {
        startSpeakRecognition(ZONE_CANDIDATES, {
          onListening: () => setRecognizerReady(true),
          onResult: ({ matchedKey }) => {
            stopInstruction();
            const zoneKey = matchedKey || fallbackWrongKey(ZONE_CANDIDATES, currentTask.correctZone);
            commitAnswer(currentTask, zoneKey);
          },
        });
      }

      playInstruction(currentTask.text, () => {
        setIsListening(false);
        setIsSpeaking(true);
      });
    }
  }, [currentTaskIndex, selectedMode, showResult]);

  const handleCardClick = () => {
    if (!isSpeaking || isProcessing) return;
    setSelectedCard(currentTask);
  };

  // Shared by both modes: 'show' (drag/click a card into a zone) and
  // 'speak' (the current task is placed based on the recognized season name).
  const commitAnswer = (card, zoneKey) => {
    const isCorrect = card.correctZone === zoneKey;

    setZones(prev => ({
      ...prev,
      [zoneKey]: [...prev[zoneKey], card]
    }));

    setAnswers(prev => [...prev, isCorrect]);
    setAnswerLog(prev => [...prev, { taskId: card.id, selectedZone: zoneKey, correct: isCorrect }]);
    setSelectedCard(null);

    setTimeout(() => {
      setIsProcessing(false);
      if (currentTaskIndex + 1 < totalQuestions) {
        setCurrentTaskIndex(prev => prev + 1);
        setHasSpoken(false);
      } else {
        setShowResult(true);
      }
    }, 800);
  };

  const handlePlaceCard = (zoneKey) => {
    if (!selectedCard || isProcessing) return;
    setIsProcessing(true);
    stopInstruction();
    commitAnswer(selectedCard, zoneKey);
  };

  useEffect(() => {
    if (showResult) {
      const timer = setTimeout(() => {
        const correctCount = answers.filter(a => a === true).length;
        const score = Math.round((correctCount / totalQuestions) * 100);
        if (onComplete) {
          onComplete({
            testId: 'Seasons',
            score,
            details: { total: totalQuestions, correct: correctCount, mode: selectedMode, log: answerLog }
          });
        } else {
          onBack();
        }
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [showResult]);

  if (showResult) {
    const correctCount = answers.filter((a) => a === true).length;
    return (
      <ModuleTemplate progress={answers} totalQuestions={totalQuestions}   forceStop={true}
      onComplete={onComplete || onBack}>
        <div className="result-content">
          <h2 className="result-title">🎉 Упражнение завершено!</h2>
          <div className="result-score">
            <span className="score-number">{correctCount}</span>
            <span className="score-total"> / {totalQuestions}</span>
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  if (!currentTask) return (
    <ModuleTemplate progress={answers} totalQuestions={totalQuestions}   forceStop={true}
      onComplete={onComplete || onBack}>
      <div className="loading-text">Выберите режим ниже, чтобы начать</div>
    </ModuleTemplate>
  );

  return (
    <ModuleTemplate
      progress={answers}
      totalQuestions={totalQuestions}
      forceStop={true}
      onComplete={onComplete || onBack}
      disabled={!selectedMode}
    >
            <div className={`daily-routine-container ${selectedCard ? 'card-is-selected' : ''}`}>

        {!selectedMode && (
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', marginBottom: '30px' }}>
            <button onClick={() => setSelectedMode('speak')} style={{ padding: '14px 28px', borderRadius: '50px', border: `2px solid ${blinkTarget === 'speak' ? '#7C3AED' : '#E5E0F5'}`, background: blinkTarget === 'speak' ? '#EDE9FE' : '#F8F6FF', color: '#1A1A2E', fontWeight: '600', cursor: 'pointer', fontFamily: 'Inter, sans-serif', fontSize: '18px', transition: 'all 0.3s', boxShadow: blinkTarget === 'speak' ? '0 4px 20px rgba(124, 58, 237, 0.35)' : '0 4px 15px rgba(0,0,0,0.05)' }}>🎙️ Говорить</button>
            <button onClick={() => setSelectedMode('show')} style={{ padding: '14px 28px', borderRadius: '50px', border: `2px solid ${blinkTarget === 'show' ? '#7C3AED' : '#E5E0F5'}`, background: blinkTarget === 'show' ? '#EDE9FE' : '#F8F6FF', color: '#1A1A2E', fontWeight: '600', cursor: 'pointer', fontFamily: 'Inter, sans-serif', fontSize: '18px', transition: 'all 0.3s', boxShadow: blinkTarget === 'show' ? '0 4px 20px rgba(124, 58, 237, 0.35)' : '0 4px 15px rgba(0,0,0,0.05)' }}>👆 Показать</button>
          </div>
        )}

        <div className="routine-main-area">
          
          <div className="routine-board-wrapper">
            <img 
              src="https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru/awareness/board_seasons.png" 
              alt="Времена года" 
              className="routine-board-bg"
            />
            <div className="routine-zones-grid">
              {ZONES.map(zone => (
                <div 
                  key={zone.key} 
                  className={`routine-zone ${selectedCard ? 'zone-active' : ''}`}
                  onClick={() => handlePlaceCard(zone.key)}
                >
                  <div className="routine-zone-items">
                    {zones[zone.key].map(item => (
                      <div key={item.id} className="routine-zone-item">
                        <img 
                          src={`${S3_BASE_URL}/${item.img}.png`} 
                          alt={item.text} 
                          className="routine-zone-img"
                          onError={(e) => { e.target.src = '/placeholder.png'; }} 
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="routine-active-card-wrapper">
            <div 
              className={`routine-active-card ${selectedCard ? 'selected' : ''}`} 
              onClick={handleCardClick}
            >
              <img 
                src={`${S3_BASE_URL}/${currentTask.img}.png`} 
                alt={currentTask.text} 
                className="routine-active-img" 
                onError={(e) => { e.target.src = '/placeholder.png'; }} 
              />
            </div>
            
            <div className="routine-indicators">
              <div className={`indicator listen ${isListening ? 'active' : ''}`}><span className="indicator-icon">🎧</span></div>
              <div className={`indicator speak ${isSpeaking && (selectedMode !== 'speak' || recognizerReady) ? 'active' : ''}`}><span className="indicator-icon">🗣️</span></div>
            </div>
          </div>

        </div>

      </div>
    </ModuleTemplate>
  );
};

export default Seasons;